// Effect Managers
import { take, fork } from 'redux-saga/effects'

// Constants
import {
  ONCE,
} from './constants'

// Sagas
import composeHandleRead from './sagas/composeHandleRead'
import composeHandleCreate from './sagas/composeHandleCreate'
import composeHandleUpdate from './sagas/composeHandleUpdate'
import composeHandleDelete from './sagas/composeHandleDelete'

function compose (actionType, lifetime, saga) {
  return function *watcher () {
    // Watch one time only
    if (lifetime === ONCE) {
      const { payload, meta } = yield take(actionType)

      if (!meta.stopPropagation) {
        yield fork(saga, {...payload}, meta)
      }

    // Watch until cancelled
    } else {
      while (true) {
        const { payload, meta } = yield take(actionType)

        if (!meta.stopPropagation) {
          yield fork(saga, {...payload}, meta)
        }
      }
    }
  }
}

export default function ({
  state,
  actionTypes,
  actionCreators,
  token$,
  handleFetch,
}) {
  const watchers = []
  const sagas = {}
  const composerOptions = {
    actionCreators,
    actionTypes,
    url: state.get().url,
    token$,
    handleFetch,
  }

  const permissions = state.permissions()

  if (permissions.create) {
    const create = composeHandleCreate(composerOptions)
    sagas.create = create

    const lifetime = state.get().watch.create
    if (lifetime !== false) {
      watchers.push(compose(actionTypes.create(), lifetime, create))
    }
  }

  if (permissions.read) {
    const read = composeHandleRead(composerOptions)
    sagas.read = read

    const lifetime = state.get().watch.read
    if (lifetime !== false) {
      watchers.push(compose(actionTypes.fetch(), lifetime, read))
    }
  }

  if (permissions.update) {
    const update = composeHandleUpdate(composerOptions)
    sagas.update = update

    const lifetime = state.get().watch.update
    if (lifetime !== false) {
      watchers.push(compose(actionTypes.update(), lifetime, update))
    }
  }

  if (permissions.delete) {
    const delete_ = composeHandleDelete(composerOptions)
    sagas.delete = delete_

    const lifetime = state.get().watch.delete
    if (lifetime !== false) {
      watchers.push(compose(actionTypes.delete(), lifetime, delete_))
    }
  }

  const watch = watchers.length
    ? function *watch () {
      const tasks = watchers.map((watcher) => fork(watcher))
      console.info(state.get().model)
      yield tasks
    }
    : function () {}

  return {
    watch,
    sagas,
  }
}
